export default __webpack_public_path__ + "static/logo-kam-203b4b621133d2a92accc1de92dab20c.png";